var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-skeleton pulse"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"skeleton-card"}),_c('div',{staticClass:"skeleton-card"}),_c('div',{staticClass:"skeleton-card"}),_c('div',{staticClass:"skeleton-card"}),_c('div',{staticClass:"skeleton-card"})])
}]

export { render, staticRenderFns }